var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllfiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 49",
    enableBackground: "new 0 0 60 49",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,18c-0.3,0-0.5,0.2-0.5,0.4L2,47v1c0,0.7,0,1,0.6,1h44.8c1.2,0,2.2-0.8,2.5-1.8L60,19c0,0,0-0.6,0-1H14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,16H53h1V9.7C54,8.2,52.8,7,51.3,7H26.5l-5-7H2.7C1.2,0,0,1.2,0,2.7v41.8l10.3-26.7C10.6,16.8,11.6,16,12.7,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllfiles);
export default __webpack_public_path__ + "static/media/allfiles.08ff0d73.svg";
export { ForwardRef as ReactComponent };